var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shipment-summary"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('legend', [_vm._v("Shipment Summary/Bag Details")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Shipping ID",
      "name": "shippingID",
      "id": "shippingID",
      "maxlength": 25
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getBagDetailsByShippingID.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), (_vm.shipmentIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.shippingIDErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBagDetailsByShippingID
    }
  }, [_vm._v("Show Shipment Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openFollowUpWindow
    }
  }, [_vm._v("Raise Follow Up")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-left": "-11px"
    }
  }, [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "bagNo",
      "id": "bagNo"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getBagDetailsByBagNo.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), (_vm.bagIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagIDErrorMSG))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-23px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getBagDetailsByBagNo
    }
  }, [_vm._v("Show Bag Log")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "36px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), (_vm.showShipmentDetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Prexo Order ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Prexo Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Final Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RTO Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Order Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Process Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MOT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RTO Process Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sub Cluster Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Items")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Raise Follow Up")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("View Transit Status")])])]), _vm._v(" "), _c('tbody', [(_vm.isEmpty > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ShippingId))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ClientId))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.Status))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.Tags))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ShipmentStatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ShipmentType))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.PrexoIDAWB))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ExchangeType ? _vm.shippingDetails.ExchangeType : ''))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.OriginHubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.CurrentHubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.FinalDestinationName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.RTOHubName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.OrderType))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.ServiceType))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.HubProcessCode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.mot))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.RTOProcessCode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.SubClusterName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.TotalItems))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "fa fa-eye",
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    on: {
      "click": function($event) {
        return _vm.showModalOnClick(_vm.shippingDetails)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "fa fa-shield fa-rotate-180",
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    on: {
      "click": function($event) {
        return _vm.openFollowUpModal(_vm.shippingDetails.ShippingId)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#20a8d8"
    },
    on: {
      "click": function($event) {
        return _vm.viewTransitStatusShipment()
      }
    }
  }, [_vm._v("View Transit Status")])])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.shippingDetails).length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "22"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showShipmentDetailsTable) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Dimensions")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("PDD/EDD Details")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "1"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("RTO Details")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Notification Details")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "15px"
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("L")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("B")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("H")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Phy. Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vol. Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("RTO/DTO PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("EDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Name, Address, City, PinCode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Notification Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Notification Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Date")])])]), _vm._v(" "), _c('tbody', [(_vm.isEmpty > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.shippingDetails.PackageDetails.Dimensions.Length)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.shippingDetails.PackageDetails.Dimensions.Width)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.shippingDetails.PackageDetails.Dimensions.Height)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.shippingDetails.PackageDetails.Weight.PhyWeight)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.shippingDetails.PackageDetails.Weight.VolWeight)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shippingDetails.PDD)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shippingDetails.RTOPDD)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shippingDetails.EDD)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.RTOName) + "," + _vm._s(_vm.shippingDetails.RTOAddress) + ",City: " + _vm._s(_vm.shippingDetails.RTOCity) + "-" + _vm._s(_vm.shippingDetails.RTOPinCode))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.NotificationStatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.NotificationType))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.shippingDetails.CreatedBy))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shippingDetails.CreatedDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.shippingDetails.ShippingDate)))])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.shippingDetails).length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "14"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.openTransitStatusShipment == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.openTransitStatusShipment),
      callback: function($$v) {
        _vm.openTransitStatusShipment = $$v
      },
      expression: "openTransitStatusShipment"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transit Status Data For Shipments")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeTransitStatusShipment
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("schedule date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.TransitStatusData), function(data, index) {
    return (_vm.TransitStatusData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionSourceHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionDestinationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.scheduledate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.TransitStatusData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showBagdetailsTable) ? _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Seal No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), (_vm.groupFlag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group No")]) : _vm._e(), _vm._v(" "), (_vm.groupFlag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Group Name")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipments Details")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Log")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("View Transit Status")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagDetails.BagDetails), function(data, index) {
    return (_vm.bagDetails.BagDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sealno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), (_vm.groupFlag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupNo))]) : _vm._e(), _vm._v(" "), (_vm.groupFlag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.groupName))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("BagCategory")(data.isparentbag)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showShipmentDetails(data.sealno)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showModalOnClickBag(_vm.bagDetails)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.viewTransitStatus()
        }
      }
    }, [_vm._v("View Transit Status")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagSealChangeMessage) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v(_vm._s(_vm.bagSealChangeMessage))])]) : (_vm.bagDetails.length < 1 && _vm.bagSealChangeMessage == '') ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e()], 1)], 1)])]), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Transactions Log"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transactions Log")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-3 border",
    on: {
      "click": _vm.additionalEnevtLogsPage
    }
  }, [_vm._v("\n            View Other Logs\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.transactions), function(data, index) {
    return (_vm.transactions.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ProcessLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CurrentLocationName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center newline"
    }, [_vm._v(_vm._s(data.Comments)), (data.Latitude) ? _c('p', [_vm._v(" [ Lat , Long: " + _vm._s(data.Latitude) + " , " + _vm._s(data.Longitude) + " ] ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.CreatedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CreatedBy))])]) : _vm._e()
  }), _vm._v(" "), (_vm.shippingDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showModalBag == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showModalBag),
      callback: function($$v) {
        _vm.showModalBag = $$v
      },
      expression: "showModalBag"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Audit Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeBagModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process Location Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Process")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.auditLog), function(data, index) {
    return (_vm.auditLog.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.processlocationname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.process))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.comment))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showbagShipmentDetailsModal == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.showbagShipmentDetailsModal),
      callback: function($$v) {
        _vm.showbagShipmentDetailsModal = $$v
      },
      expression: "showbagShipmentDetailsModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Bag Shipment Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closebagShipmentDetailsModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Bagno")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No/Shippingid")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hubid")]), _vm._v(" "), (_vm.ShowMPSID) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS GroupID")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Overage BagNo")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bagShipmentDetails), function(data, index) {
    return (_vm.bagShipmentDetails.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno) + _vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))]), _vm._v(" "), (_vm.ShowMPSID) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.multishipmentgroupid))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.overagebagno))])]) : _vm._e()
  }), _vm._v(" "), (_vm.bagDetails.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.openTransitStatus == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Audit Log"
    },
    model: {
      value: (_vm.openTransitStatus),
      callback: function($$v) {
        _vm.openTransitStatus = $$v
      },
      expression: "openTransitStatus"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Transit Status Data For Bags")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeTransitStatus
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto",
      "height": "450px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Source Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("schedule date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.TransitStatusData), function(data, index) {
    return (_vm.TransitStatusData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionSourceHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionDestinationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.scheduledate)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.TransitStatusData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])])]) : _vm._e(), _vm._v(" "), (_vm.followUpModal == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Raise Follow Up",
      "no-close-on-backdrop": true,
      "no-close-on-esc": true
    },
    model: {
      value: (_vm.followUpModal),
      callback: function($$v) {
        _vm.followUpModal = $$v
      },
      expression: "followUpModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Raise Follow Up Request")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeFollowUpModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isFollowUpLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isFollowUpLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "followUp"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipping ID"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ShippingID),
      expression: "ShippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('followUp.ShippingID')
    },
    attrs: {
      "type": "text",
      "rows": "2",
      "max-rows": "10",
      "placeholder": "Enter ShippingID. Use comma(,) for multiple ShipmentIDs and Maximum Limit is 50",
      "name": "ShippingID",
      "id": "ShippingID"
    },
    domProps: {
      "value": (_vm.ShippingID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ShippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('followUp.ShippingID')),
      expression: "errors.has('followUp.ShippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('followUp.ShippingID')) + " ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("FollowUp Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('followUp.FollowUpType')
    },
    attrs: {
      "options": _vm.FollowUpData,
      "selected-option": _vm.FollowUpObjData,
      "name": "FollowUpType",
      "placeholder": "Select FollowUp Type"
    },
    on: {
      "select": _vm.selectedfollowUpType
    },
    model: {
      value: (_vm.FollowUpType),
      callback: function($$v) {
        _vm.FollowUpType = $$v
      },
      expression: "FollowUpType"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('followUp.FollowUpType')),
      expression: "errors.has('followUp.FollowUpType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('followUp.FollowUpType')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('label', [_vm._v("Date")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    ref: "pdddate",
    attrs: {
      "lang": "en",
      "type": "pdddate",
      "name": "pdddate",
      "format": "DD-MM-YYYY",
      "not-before": _vm.todaysDate,
      "not-after": new Date(_vm.todaysDate).setDate(new Date(_vm.todaysDate).getDate() + 30),
      "data-vv-scope": "followUp"
    },
    on: {
      "change": _vm.selectedDate
    },
    model: {
      value: (_vm.pdddate),
      callback: function($$v) {
        _vm.pdddate = $$v
      },
      expression: "pdddate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.pdddateError))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("FollowUp Description"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Description),
      expression: "Description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('followUp.Description')
    },
    attrs: {
      "type": "text",
      "rows": "10",
      "max-rows": "10",
      "placeholder": "Enter Followup Description",
      "name": "Description",
      "id": "Description"
    },
    domProps: {
      "value": (_vm.Description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('followUp.Description')),
      expression: "errors.has('followUp.Description')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('followUp.Description')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Save")]), _vm._v("  \n              "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.resetFields
    }
  }, [_vm._v("Reset")])])])], 1)])])]) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdf8ff34","hasScoped":true}!./src/views/components/BagShipmentQuery/ShipmentBagSummary/ShipmentBagSummary.html
// module id = 1136
// module chunks = 2